import React, {useState, useEffect, useLayoutEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import renderHTML from 'react-render-html';
import _ from "lodash";
import './Menu.sass';
import gsap from 'gsap';
import {gotoLocation} from '../../store/actions/course.action';
import ProgressIcon from './ProgressIcon';
import MapIcon from './MapIcon';

const Menu = ({course}) => {
    const pageStatus = useSelector((state) => state.course.pageStatus)
    const dispatch = useDispatch();


    useEffect(() => {
        console.log("Menu pageStatus update()");
    }, [pageStatus]);

    const handleNavigation = (event) => {
        let id = event.currentTarget.id;
        let index = _.findIndex(course.content, {"id": id})
        dispatch(gotoLocation([index, 0]));
    };

    const checkStatus = (id) => {
        if (pageStatus.length === 0) {
            return 0;
        }
        let index = _.findKey(course.content, {"id": id})
        let chapter = pageStatus[index];
        let status = 2
        let noneStarted = true;
        for (let i = 0; i < chapter.length; i++) {
            let p = chapter[i];
            if (p != 2) {
                status = 1
            }
            if (p != 0) {
                noneStarted = false;
            }
        }
        if (noneStarted) {
            status = 0
        }
        return status;
    };


    return <div className="Menu"
                style={course.background && {
                    "backgroundImage": "url(" + course.background + ")"
                }}>
        <div className="menu-panel">
            <div className="course-title">{course.courseTitle}</div>
            <div className="course-sub-title">{course.courseSubTitle}</div>

            <div className="menu-content">
                {course.menu.items.map((item, index) => (
                    <div className="menu-button"
                         key={index}>
                        <button id={item.id}
                                onClick={(event) => handleNavigation(event)}>
                            <ProgressIcon status={checkStatus(item.id)}/>
                            <span className="uppercase">{item.title}</span>
                        </button>
                    </div>
                ))}

            </div>
        </div>
    </div>

};

export default Menu;
